import { memo } from "react";
import { HeaderWrapper, Title, StyledLink, UserName, Button } from "./style";

const Header = memo((props) => {
  const { onLoginClick, onLogoutClick, user } = props;

  return (
    <HeaderWrapper>
      <Title>
        <StyledLink to="/">Card Maker</StyledLink>
      </Title>
      {user.loggedIn ? (
        <>
          <UserName>{user.userName} 님</UserName>
          <Button onClick={onLogoutClick}>로그아웃</Button>
        </>
      ) : (
        <Button className="btn" onClick={onLoginClick}>
          로그인
        </Button>
      )}
    </HeaderWrapper>
  );
});

export default Header;
